import React from 'react';
const painPoints = ['El domingo a la noche no podés parar de pensar en el paciente del lunes. Repasás el caso en loop sin llegar a ninguna conclusión.', 'Tus pacientes llevan meses en tratamiento y sentís que dan vueltas siempre en lo mismo. No sabés si el estancamiento es de ellos o tuyo.', 'Un paciente entra en crisis en medio de la sesión y por dentro entrás en pánico. Actuás pero después te quedás con la duda de si hiciste lo correcto.', 'Terminás el día agotado/a emocionalmente. Te llevás los casos a casa, a la cena, a la cama. Y eso te está quemando.', 'Un paciente desaparece sin aviso después de meses de proceso y no sabés si llamarlo, esperarlo o dejarlo ir. Te quedás con la culpa.', 'Sentís que tu formación te dio teoría pero no te preparó para lo que pasa de verdad adentro del consultorio cuando el caso se complica.'];
export function PainPoints() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(254,242,242) 0%, rgb(254,242,242) 15%, rgb(254,242,242) 85%, rgb(255,255,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-188">
      <div className="mx-auto max-w-3xl" data-id="element-189">
        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-500 mb-2" data-id="element-190">
          ¿Te sentís identificado/a?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-gray-900 m-0 mb-2" data-id="element-191">
          Esto le pasa al 90% de los terapeutas
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-192">
          No es falta de vocación. Es falta de un sistema.
        </p>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-193">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white border border-red-200 rounded-lg p-3 shadow-sm" data-id="element-194">
              <span className="text-red-500 text-base leading-5 shrink-0" data-id="element-195">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-800 m-0" data-id="element-196">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-violet-700 m-0 mb-6" data-id="element-197">
          ¿Cuántos casos más vas a sostener sin un sistema?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255, 255, 255, 0), rgb(124, 58, 237), rgba(255, 255, 255, 0))'
      }} data-id="element-198" />
      </div>
    </section>;
}